<script setup lang="ts">
import { computed } from 'vue';
import { VCard } from 'vuetify/components';

type PropsType = {
    elevation?: string | number;
    variant?: VCard['$props']['variant'];
    titleClass?: string;
    textClass?: string;
    actionsClass?: string;
    class?: string | string[];
};

const props = withDefaults(defineProps<PropsType>(), { variant: 'elevated' });

const getClass = computed(() => {
    return props.class ? `b-card ${props.class}` : 'b-card pa-4';
});

defineOptions({ inheritAttrs: false });
</script>

<template>
    <VCard
        :elevation="elevation"
        :variant="variant"
        v-bind="$attrs"
        :class="getClass"
    >
        <template v-if="$slots.title || $slots.subtitle">
            <VCardTitle :class="titleClass">
                <slot name="title" />
                <template v-if="$slots.subtitle">
                    <div class="text-subtitle-1">
                        <slot name="subtitle" />
                    </div>
                </template>
            </VCardTitle>
        </template>

        <template v-if="$slots.default">
            <VCardText :class="textClass">
                <slot />
            </VCardText>
        </template>

        <template v-if="$slots.actions">
            <VCardActions :class="actionsClass">
                <slot name="actions" />
            </VCardActions>
        </template>
    </VCard>
</template>

<style lang="scss" scoped>
.b-card.v-card--variant-elevated {
    box-shadow:
        0 4px 18px rgba(47, 43, 61, 0.1),
        0 0 transparent,
        0 0 transparent;
}
.b-card.b-card--flat-w-border {
    background-color: rgba(var(--v-theme-background-layout), 0.5);
    border: 1px solid rgb(170 170 170 / 10%);
}
</style>
